export default __webpack_public_path__ + "static/media/bank-placeholder.48b6e97a.svg";